import React, { useEffect, useMemo, useState } from 'react';
import { FormSelect, FilterWidget, MasterDetailForm, FormSubmitButton, Button, FormInput, usePromise, OptionProps } from '@digital/ui';
import { getAllClassificaoRfaOptions } from '@app/api/status';
import { getAllCategoriaOptions } from '@app/api/categoria';
import { getAllPacoteDisciplinaOptions, getAllPacoteTipoOptions } from '@app/api/pacoteDisciplina';
import { getAllOrcamentarioOptions } from '@app/api/orcamentario';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllAreasOptions } from '@app/api/area';
import { getAllDepartamentoOptions } from '@app/api/departamento';
import { getAllCrfTipoProjetoFaseOptions } from '@app/api/crf/crfTipoProjetoFase';
import { Filtros } from '@app/api/relatorioCicloorcamentario';

const FiltrosRelatorioCicloOrcamentarioPluriAnual = (props: { onSearch: () => {}, atualizarTela: Function }) => {
    const { onSearch, atualizarTela } = props;

    const [classificaoRfaOptions] = usePromise(getAllClassificaoRfaOptions, [], [] as OptionProps[]);
    const [categoriaOptions] = usePromise(getAllCategoriaOptions, [], [] as OptionProps[]);
    const [pacoteDisciplinaOptions] = usePromise(getAllPacoteDisciplinaOptions, [], [] as OptionProps[]);
    const [pacoteTipoOptions] = usePromise(getAllPacoteTipoOptions, [], [] as OptionProps[]);
    const [orcamentarioOptions] = usePromise(getAllOrcamentarioOptions, [], [] as OptionProps[]);
    const [diretoriasOptions] = usePromise(getAllDiretoriasOptions, [], [] as OptionProps[]);
    const [areasOptions] = usePromise(getAllAreasOptions, [], [] as OptionProps[]);
    const [departamentoOptions] = usePromise(getAllDepartamentoOptions, [], [] as OptionProps[]);
    const [tipoOptions] = usePromise(getAllCrfTipoProjetoFaseOptions, [], [] as OptionProps[]);

    const [valorInicial, setValorInicial] = useState<Filtros>({} as Filtros);
    const [trocarValor, setTrocarValor] = useState<boolean>(true);


    const valorPadrao = {
        codigoProjeto: "",
        nomeProjeto: "",
        requisitosAmbientais: "",
        classificaoRfa: [],
        diretoria: [],
        area: [],
        departamento: [],
        categoria: [],
        tipo: [],
        pacoteDisciplina: [],
        pacoteTipo: [],
        orcamentario: [],
        fase: [],
        trocarValor: false
    } as Filtros;

    const limparFormulario = () => {
        const trocarValorTeste = trocarValor;
        setTrocarValor(!trocarValor);
        setValorInicial({ ...valorPadrao, trocarValor: trocarValorTeste });
        onSearch();
    };

   

    return (
        <MasterDetailForm
            key="filtroPesquisa"
            initialValues={valorInicial}
            onSubmit={onSearch}>
            <FilterWidget
                title="FILTROS DE PESQUISA"
                actions={[
                    <Button
                        type="link"
                        title="Limpar"
                        onClick={() => { limparFormulario(); }}
                    />,
                    <FormSubmitButton icon={'commons-search'}>Pesquisar</FormSubmitButton>
                ]}>

                <div className="ant-row">

                    <FormInput
                        name="codigoProjeto"
                        id="codigoProjeto"
                        label="Código do Projeto"
                        span={3}
                        allowClear
                    />


                    <FormInput
                        name="nomeProjeto"
                        id="nomeProjeto"
                        label="Nome do Projeto"
                        span={3}
                        allowClear
                    />

                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="classificaoRfa"
                        id="classificaoRfa"
                        label="Status RFA"
                        options={classificaoRfaOptions}
                        span={3}
                        allowClear
                    />


                    <FormInput
                        name="requisitosAmbientais"
                        id="requisitosAmbientais"
                        label="Requisitos Ambientais"
                        span={3}
                        allowClear
                    />


                </div>

                <div className="ant-row">


                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="diretoria"
                        id="diretoria"
                        label="Diretoria"
                        options={diretoriasOptions}
                        span={3}
                        allowClear
                    />


                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="area"
                        id="area"
                        label="Área"
                        options={areasOptions}
                        span={3}
                        allowClear
                    />

                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="departamento"
                        id="departamento"
                        label="Departamento"
                        options={departamentoOptions}
                        span={3}
                        allowClear
                    />

                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="pacoteTipo"
                        id="pacoteTipo"
                        label="Pacote/Tipo"
                        options={pacoteTipoOptions}
                        span={3}
                        allowClear
                    />

                </div>

                <div className="ant-row">

                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="pacotedisciplina"
                        id="pacotedisciplina"
                        label="Pacote/Disciplina"
                        options={pacoteDisciplinaOptions}
                        span={3}
                        allowClear
                    />

                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="categoria"
                        id="categoria"
                        label="Categoria"
                        options={categoriaOptions}
                        span={3}
                        allowClear
                    />

                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="orcamentario"
                        id="orcamentario"
                        label="Orçamentário"
                        options={orcamentarioOptions}
                        span={3}
                        allowClear
                    />


                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="tipo"
                        id="tipo"
                        label="Tipo"
                        options={tipoOptions}
                        span={3}
                        allowClear
                    />

                </div>

            </FilterWidget>
        </MasterDetailForm >
    );
};

export default FiltrosRelatorioCicloOrcamentarioPluriAnual;





